import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { H3, H4 } from '../../styles/FontStyles';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../styles/FontStyles';

import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconPortfolioOrders,
  IconPortfolioRevenue
} from '../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { formatDecimalNumber, formatUSD } from '../../helpers/helperFunctions';
import { PortfolioGamingItem } from './PortfolioGamingItem';

import { claimGamingRewards, getMyHubsGaming } from './Portfolio.actions';
import { WithdrawStepsEnum } from './WithdrawHubs/types';

interface GamingHubProps {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  withdrawStep: WithdrawStepsEnum;
}

export const GamingHubSummary = ({
  withdrawStep,
  setWithdrawStep
}: GamingHubProps) => {
  const [expanded, setExpanded] = useState(true);
  const ref = useRef<any>(null);

  const { t } = useTranslation('my_hubs');

  const dispatch = useAppDispatch();

  const { gaming } = useAppSelector((state) => state.portfolio);

  useEffect(() => {
    if (gaming !== null) return;
    dispatch(getMyHubsGaming());
  }, [dispatch]);

  const [height, setHeight] = useState(ref?.current?.clientHeight);

  useEffect(() => {
    setHeight(ref?.current?.clientHeight);
  }, [gaming]);

  return (
    <div style={{ marginBottom: 40 }}>
      <Flexed mb='20' center between>
        <H3>{t('my_gaming_hub_nfts_summary')}</H3>
      </Flexed>

      <SummaryGrid>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('total_gaming_hub_nft_orders')}
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(gaming?.summary?.totalOrderAmount)}
              <P3 mb='1'>USDT</P3>
            </P1>
          </div>
        </BoxPortfolio>

        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioRevenue />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('revenue_share_points')}
            </CaptionText>
            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(gaming?.summary?.totalRsp)} <P3 mb='1'>RSP</P3>
            </P1>
          </div>
        </BoxPortfolio>

        <BoxPortfolio hasButton>
          <Flexed center>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioRevenue />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('gaming_hub_rewards')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                <P1 bold flex alignEnd gap='5px'>
                  {formatDecimalNumber(
                    gaming?.summary?.availableUsdtToClaim
                      ? gaming?.summary?.availableUsdtToClaim
                      : 0
                  )}
                  <P3 mb='1'>uUSDT</P3>
                </P1>
              </P1>
            </div>
          </Flexed>
          <Button
            w='100px'
            h='34px'
            disabled={gaming && gaming?.summary?.availableUsdtToClaim < 1}
            onClick={() => {
              dispatch(claimGamingRewards());
            }}>
            {t('claim.claim')}
          </Button>
        </BoxPortfolio>
      </SummaryGrid>

      <Flexed center between wrap>
        <Flexed
          mb='20'
          center
          gap='20px'
          pointer
          onClick={() => setExpanded(!expanded)}>
          <H4>{t('my_gaming_hub_nfts')}</H4>
          <ArrowChevron direction={expanded ? 'up' : 'down'} />
        </Flexed>
      </Flexed>

      <Collapsable expanded={expanded} elementHeight={height}>
        <div ref={ref}>
          {gaming?.userPackages?.map((item: any, i: number) => (
            <PortfolioGamingItem
              key={i}
              item={item}
              withdrawStep={withdrawStep}
              setWithdrawStep={setWithdrawStep}
            />
          ))}
        </div>
      </Collapsable>
    </div>
  );
};
